import React from 'react';

export const playerDisplayName = (p) => p?.name || p?.full_name || p?.username || '?';

export const playerFirstName = (p) => playerDisplayName(p).split(' ')[0];

const initials = (p) => playerDisplayName(p).split(' ').slice(0, 2).map((w) => w[0]?.toUpperCase() ?? '').join('');

const hueOf = (p) =>
  Math.abs([...playerDisplayName(p)].reduce((h, c) => ((h << 5) - h + c.charCodeAt(0)) | 0, 0)) % 360;

/** Round avatar: profile photo, or coloured initials derived from the name. */
const PlayerAvatar = ({ player }) => {
  const hue = hueOf(player);
  const avatarSrc = player?.avatar_url || player?.avatarUrl || player?.profile_image || null;
  return (
    <span
      className="vb-adv-player-avatar"
      style={avatarSrc ? {} : {
        background: `linear-gradient(135deg,hsl(${hue},55%,28%),hsl(${(hue + 40) % 360},55%,22%))`,
        border: `2px solid hsl(${hue},55%,45%)`,
        color: `hsl(${hue},80%,80%)`,
      }}
    >
      {avatarSrc
        ? <img src={avatarSrc} alt="" className="vb-adv-player-avatar-img" onError={(e) => { e.target.style.display = 'none'; }} />
        : initials(player)}
    </span>
  );
};

export default PlayerAvatar;
